var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-calendar-wrap"},[_c('button',{staticClass:"prev-day",on:{"click":_vm.onClickBtnPrev}}),_c('single-calendar',{attrs:{"show-date-format":_vm.showDateFormat,"start-date":_vm.date},on:{"update":_vm.onUpdateDate}}),_c('button',{staticClass:"next-day",on:{"click":_vm.onClickBtnNext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }